import { render, staticRenderFns } from "./comments_list.vue?vue&type=template&id=47dcc66a&scoped=true"
import script from "./comments_list.vue?vue&type=script&lang=js"
export * from "./comments_list.vue?vue&type=script&lang=js"
import style0 from "./comments_list.vue?vue&type=style&index=0&id=47dcc66a&prod&scoped=true&lang=less"
import style1 from "./comments_list.vue?vue&type=style&index=1&id=47dcc66a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcc66a",
  null
  
)

export default component.exports